import React, { useState } from 'react';
import axios from 'axios';
import Footer from '../Footer';
import Navbar from '../Navbar';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post('http://localhost:5000/api/auth/forgot-password', { email });
      alert(res.data.message);
      setEmail('');
    } catch (err) {
      alert('Failed to send reset link');
    }
  };

  return (
    <>
    <Navbar/>
    <div className="max-w-md mx-auto mt-10 p-6 bg-white shadow rounded">
      <h2 className="text-xl font-bold text-blue-800 mb-4">Forgot Password</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="email"
          placeholder="Enter your registered email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="w-full border p-2 rounded"
        />
        <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700">
          Send Reset Link
        </button>
      </form>
    </div>
    <Footer/>
    </>
  );
};

export default ForgotPassword;
